/*
 * product-page-v2.js
 * ES5. Clone generalizado do JS da Duna (sections/duna-lp-3.liquid) para a pagina
 * de produto v2 (sections/product-page-v2.liquid). Um produto real por pagina
 * (nao dois como a Duna finos/grossos): variantes vem direto de cfg.variants e
 * casam pelas opcoes reais do produto (option1/2/3), sem hack de "tier".
 *
 * Todo o DOM dinamico e montado via createElement/textContent/setAttribute
 * (sem innerHTML), mesmo os dados vindo do proprio catalogo (fonte confiavel).
 *
 * Guarda de seguranca (assinatura): apos /cart/add.js, se o item devia vir com
 * selling_plan_allocation e nao veio, removemos o item (POST /cart/change.js
 * qty:0) e mostramos erro no CTA em vez de deixar uma compra cheia silenciosa
 * entrar no carrinho. A causa conhecida desse sintoma era o interceptador de
 * window.fetch do Appstle (ver pristineFetch); a guarda fica como defesa.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('Pp2Cfg');
  if (!cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);

  var root = document.getElementById('Pp2');
  if (!root) return;

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  // Espelha o money_format da loja (R$ {{amount_with_comma_separator}}): ponto no
  // milhar, virgula no centavo. Sem o ponto do milhar, um valor renderizado pelo
  // Liquid (R$ 1.049,00) e reescrito por este JS (R$ 1049,00) mudava sozinho na tela.
  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return 'R$ ' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }
  function empty(node) { while (node.firstChild) { node.removeChild(node.firstChild); } }

  function makeEl(tag, opts) {
    var e = document.createElement(tag);
    opts = opts || {};
    if (opts.className) e.className = opts.className;
    if (opts.text != null) e.textContent = opts.text;
    if (opts.attrs) {
      for (var k in opts.attrs) {
        if (Object.prototype.hasOwnProperty.call(opts.attrs, k)) e.setAttribute(k, opts.attrs[k]);
      }
    }
    if (opts.children) {
      opts.children.forEach(function (c) { if (c) e.appendChild(c); });
    }
    return e;
  }

  function makeImg(src, w, h) {
    return makeEl('img', { attrs: { src: src || '', alt: '', width: w || 150, height: h || 150, loading: 'lazy' } });
  }

  var optionCount = (cfg.options || []).length;

  var state = {
    opt: [],
    qty: 1,
    sub: true,
    freq: null,
    img: 0
  };

  (function initOptions() {
    var startVariant = null;
    for (var i = 0; i < cfg.variants.length; i++) {
      if (cfg.variants[i].id === cfg.selected_variant_id) { startVariant = cfg.variants[i]; break; }
    }
    if (!startVariant) startVariant = cfg.variants[0];
    for (var k = 0; k < optionCount; k++) {
      state.opt[k] = startVariant ? startVariant['option' + (k + 1)] : null;
    }
  })();

  function variant() {
    var vs = cfg.variants;
    if (optionCount === 0) return vs[0];
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i], ok = true;
      for (var k = 0; k < optionCount; k++) {
        if (state.opt[k] != null && v['option' + (k + 1)] !== state.opt[k]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return vs[0];
  }

  function plansFor(v) { return (v && v.plans) || []; }

  /* Regra de oferta (compare-at) num lugar so: o painel e a barra fixa liam o mesmo
     dado em dois lugares e duplicar a conta e justamente como os dois passam a
     discordar na tela. pct >= 1 evita um selo "-0%" quando o compare-at e 1 centavo
     maior. Guardado: compare_at_price vem null do Liquid quando o campo esta vazio. */
  function saleInfo(v) {
    var cmp = v.compare_at_price;
    var pct = (typeof cmp === 'number' && cmp > v.price) ? Math.round((1 - v.price / cmp) * 100) : 0;
    return { onSale: pct >= 1, pct: pct, cmp: cmp };
  }

  function freqEntry() {
    var v = variant();
    var plans = plansFor(v);
    if (!plans.length) return null;
    for (var i = 0; i < plans.length; i++) {
      if (plans[i].group === state.freq) return plans[i];
    }
    return plans[0];
  }

  function nativePlan() {
    return freqEntry();
  }

  /* Assinatura EFETIVA. state.sub sozinho e so a intencao (nasce true), entao ler ele
     cru mente em produto sem plano: foi assim que o CTA da Pa Higienica dizia
     "Assinar e economizar". Um lugar so, usado por todos os pontos que decidem entre
     assinatura e compra unica. */
  function subAtivo() {
    return state.sub && cfg.show_sub && !!nativePlan();
  }

  /* Pre-venda EFETIVA, no mesmo espirito do subAtivo(): um lugar so decide, em vez
     de cada ponto ler o cfg cru. Ler cru em dois lugares foi o que gerou o bug do
     CTA da Pa Higienica. Exige o id do plano porque sem ele o add to cart nao tem
     o que anexar, e ai a "pre-venda" seria so enfeite. */
  function preVendaAtiva() {
    return !!(cfg.pre_venda && cfg.pre_venda_plano_id);
  }

  /* O aceite so trava o botao quando o painel pede as DUAS coisas: exigir o aceite
     e travar ate ele. Sao campos separados no STOQ, e o lojista pode querer o texto
     sem a trava. Sem pre-venda, nada a travar. */
  function aceiteOk() {
    if (!preVendaAtiva()) return true;
    if (!cfg.pre_venda_exige_aceite || !cfg.pre_venda_trava_botao) return true;
    var cb = document.getElementById('Pp2PrevAceite');
    return !!(cb && cb.checked);
  }

  function friendlyFreqLabel(plan) {
    var hay = ((plan.group || '') + ' ' + (plan.name || '')).toLowerCase();
    if (/15\s*dias|quinzenal/.test(hay)) return 'Receba a cada 15 dias';
    if (/45\s*dias/.test(hay)) return 'Receba a cada 45 dias';
    if (/90\s*dias|3\s*mes|trimestral/.test(hay)) return 'Receba a cada 3 meses';
    if (/60\s*dias|2\s*mes|bimestral/.test(hay)) return 'Receba a cada 2 meses';
    if (/30\s*dias|mensal|1\s*mes/.test(hay)) return 'Receba a cada 1 mês';
    return plan.name || plan.group || 'Assinatura';
  }

  /* ---------- galeria ---------- */
  /* GAL.all = catalogo completo de midias; GAL.media = as VISIVEIS agora (filtradas
     pela variante). O filtro segue a mesma convencao do resto do tema (o Liquid em
     snippets/product-media-gallery.liquid e o Woolie.productGallery): o ALT da midia
     carimba a variante, ex.: alt "lake menta" para a variante "Lake Menta". */
  /* target = slide para onde um scroll suave esta indo (setas/miniaturas), ou null
     quando a faixa esta parada. E dele que stepImage conta o proximo passo. */
  var GAL = { all: cfg.media || [], media: cfg.media || [], target: null };

  function normAlt(s) { return String(s == null ? '' : s).toLowerCase().replace(/^\s+|\s+$/g, ''); }

  /* Midias da variante. Fallback deliberado (igual ao Liquid do tema): se NENHUMA
     midia casar com o titulo da variante, o produto nao usa esse carimbo de alt e
     mostramos todas, em vez de deixar a galeria vazia. */
  function mediaForVariant(v) {
    var all = GAL.all;
    if (!v || optionCount === 0 || !all.length) return all;
    var title = normAlt(v.title);
    if (!title) return all;
    // Foto SEM etiqueta (alt vazio ou igual ao titulo do produto, que e o fallback do
    // Liquid) vale pra TODAS as variantes: sao as fotos de ambiente/lifestyle. Some so
    // a foto etiquetada com OUTRA coisa (outra variante, ou uma variante que ja foi
    // arquivada, ex.: alt "wave nogueira" num produto que so tem "Wave Carvalho").
    var prodTitle = normAlt(cfg.title);
    var matchedCount = 0, out = [];
    for (var i = 0; i < all.length; i++) {
      var a = normAlt(all[i].alt);
      // A foto DESTACADA da variante NUNCA e escondida pelo filtro dela: por definicao
      // ela e a foto daquela variante, independente do que o alt diga. Sem esta guarda
      // ela sumia quando o alt seguia outra convencao, e ai a galeria caia na primeira
      // foto visivel (a de grupo) em vez da cor escolhida. Caso real, GEO Basic:
      // variante "GEO Branco", destacada com alt "branco - basic", que nao bate nem com
      // o titulo da variante nem com o do produto.
      if (v.featured_media_id && all[i].id === v.featured_media_id) {
        matchedCount++; out.push(all[i]); continue;
      }
      if (a === title) { matchedCount++; out.push(all[i]); }
      else if (!a || a === prodTitle) { out.push(all[i]); }
    }
    // nenhuma foto casou com a variante: o produto nao usa essa convencao de alt,
    // entao mostra tudo em vez de deixar a galeria so com as genericas.
    return matchedCount ? out : all;
  }

  /* Recalcula a lista visivel na troca de variante. Retorna true se a galeria mudou
     (ai ela ja foi reconstruida e o chamador nao precisa fazer o pulo pra foto
     destacada). Comeca na foto destacada da variante quando ela esta na lista. */
  function idsSig(list) {
    var s = '';
    for (var i = 0; i < list.length; i++) { s += list[i].id + ','; }
    return s;
  }

  function applyGalleryFilter() {
    var v = variant();
    var next = mediaForVariant(v);
    // assinatura completa dos ids: comparar so tamanho + 1o id deixaria passar duas
    // listas diferentes de mesmo tamanho comecando na mesma midia.
    if (idsSig(next) === idsSig(GAL.media)) return false;
    GAL.media = next;
    state.img = 0;
    if (v && v.featured_media_id) {
      for (var i = 0; i < next.length; i++) {
        if (next[i].id === v.featured_media_id) { state.img = i; break; }
      }
    }
    buildGallery();
    return true;
  }

  /* Largura pela qual o navegador escolhe o candidato do srcset. A coluna da
     galeria no desktop bate no maximo em ~620px (1150 do wrap - 40 de padding -
     56 do gap - 440 do painel); no celular o slide e a tela inteira. Sem isto o
     navegador assume 100vw tambem no desktop e baixa a foto de 1200w a toa. */
  var IMG_SIZES = '(min-width: 901px) 620px, 100vw';

  /* A <img> do primeiro slide vem renderizada do servidor com fetchpriority=high:
     e o LCP desta pagina. Guardamos a referencia e a REAPROVEITAMOS a cada
     remontagem da faixa, em vez de criar outra <img>: a foto que o navegador ja
     priorizou e decodificou continua sendo a que aparece, sem segundo download
     nem piscada de fundo cinza no meio da troca de variante. */
  var seedImg = $('#Pp2MainImg');

  function mediaAlt(m) { return (m && m.alt) ? m.alt : (cfg.title || ''); }

  /* So escreve o atributo quando ele MUDOU. Reatribuir o mesmo src/srcset e o
     bastante pra o navegador rodar de novo a selecao de candidato do srcset e,
     dependendo do DPR, trocar a foto de 900w ja baixada por outra de 1200w. */
  function paintImg(img, m) {
    var ss = m.srcset || '';
    if ((img.getAttribute('srcset') || '') !== ss) {
      if (ss) img.setAttribute('srcset', ss);
      else img.removeAttribute('srcset');
    }
    if (img.getAttribute('sizes') !== IMG_SIZES) img.setAttribute('sizes', IMG_SIZES);
    if (img.getAttribute('src') !== (m.src || '')) img.setAttribute('src', m.src || '');
    img.setAttribute('alt', mediaAlt(m));
  }

  /* Caixa de video em repouso: poster + botao de play. O player de verdade so
     entra quando o scroll PARA neste slide (ver mountVideo). */
  function fillPoster(box, m) {
    box.setAttribute('data-on', '0');
    box.appendChild(makeEl('img', {
      attrs: { src: (m && m.poster) || '', alt: mediaAlt(m), loading: 'lazy', decoding: 'async' }
    }));
    box.appendChild(makeEl('span', { className: 'p-slide__play', text: '▶', attrs: { 'aria-hidden': 'true' } }));
  }

  function buildSlide(m, i) {
    var isVid = m.type === 'video' || m.type === 'external_video';
    var slide = makeEl('div', { className: 'p-slide' + (isVid ? ' p-slide--video' : '') });
    if (isVid) {
      var box = makeEl('div', { className: 'p-slide__vid', attrs: { 'data-i': String(i) } });
      fillPoster(box, m);
      slide.appendChild(box);
      return slide;
    }
    var img = (seedImg && i === state.img)
      ? seedImg
      : makeEl('img', { attrs: { width: 900, height: 900, loading: 'lazy', decoding: 'async' } });
    paintImg(img, m);
    slide.appendChild(img);
    return slide;
  }

  function buildThumb(m, i) {
    var isVid = m.type === 'video' || m.type === 'external_video';
    var b = makeEl('button', {
      className: (i === state.img ? 'is-on' : '') + (isVid ? ' p-thumb--video' : ''),
      attrs: { type: 'button' }
    });
    // m.thumb e o recorte de 200px que a secao passa a mandar no cfg. Antes a
    // tira usava o MESMO arquivo de 900px da foto grande pra desenhar 72px:
    // num produto de 21 midias eram 21 fotos em tamanho de galeria baixadas so
    // pra virem miniatura. Com os slides todos no DOM isso passou a competir por
    // banda justamente com a foto que o cliente esta olhando.
    b.appendChild(makeImg(m.thumb || m.poster || m.src, 150, 150));
    if (isVid) {
      b.setAttribute('aria-label', 'Assistir ao vídeo');
      b.appendChild(makeEl('span', { className: 'p-thumb__play', text: '▶', attrs: { 'aria-hidden': 'true' } }));
    }
    b.addEventListener('click', function () { selectImage(i); });
    return b;
  }

  function buildGallery() {
    var track = $('#Pp2Track'), thumbs = $('#Pp2Thumbs');
    if (!track || !thumbs) return;
    empty(track);
    empty(thumbs);
    GAL.media.forEach(function (m, i) {
      track.appendChild(buildSlide(m, i));
      thumbs.appendChild(buildThumb(m, i));
    });
    renderGalNav();
    // Remontou por troca de variante: assenta na foto certa SEM animar. Animar
    // aqui seria um passeio pelas fotos da cor que o cliente acabou de deixar.
    goToSlide(state.img, true);
  }

  /* ---------- navegacao da galeria: setas, miniaturas e o scroll da faixa ----------
     A galeria da v3 so tinha foto principal e miniaturas. No desktop faltava a
     seta e no celular nao dava pra arrastar, entao trocar de foto exigia mirar
     numa miniatura de 72px.

     O detector de swipe que morava aqui SAIU. Ele lia touchstart/touchend, nao
     movia nada enquanto o dedo andava e, ao soltar, disparava um fade de 180ms
     num setTimeout: a foto sumia, esperava e reaparecia trocada. Era isso o
     "tranco" do video de 08/ago. Quem passa a foto agora e o scroll nativo da
     faixa (.p-gallery__track) com scroll-snap, animado pelo compositor; este
     bloco so LE em que slide o scroll parou e mantem setas, miniaturas e
     state.img de acordo.

     As setas CICLAM (da ultima volta para a primeira) em vez de desabilitar nas
     pontas: com a lista mudando por variante, seta desabilitada vira alvo morto
     na tela. Ficam escondidas quando a variante tem uma unica midia. */

  var CAN_SMOOTH = 'scrollBehavior' in document.documentElement.style;
  var settleTimer = 0, scrollRaf = 0, lastTrackW = 0;

  function semAnimacao() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function scrollX(el, left, instant) {
    if (CAN_SMOOTH) el.scrollTo({ left: left, behavior: (instant || semAnimacao()) ? 'auto' : 'smooth' });
    else el.scrollLeft = left;
  }

  function nearestSlide() {
    var track = $('#Pp2Track');
    if (!track) return state.img;
    var w = track.clientWidth;
    if (!w) return state.img;
    return Math.max(0, Math.min(GAL.media.length - 1, Math.round(track.scrollLeft / w)));
  }

  function paintThumbs(i) {
    var thumbs = $('#Pp2Thumbs');
    if (!thumbs) return;
    $all('button', thumbs).forEach(function (btn, k) { btn.classList.toggle('is-on', k === i); });
  }

  /* Arrasta a TIRA de miniaturas, e nunca scrollIntoView: ele rola a PAGINA
     junto pra trazer a tira pro centro da tela, e a foto que o cliente acabou
     de escolher sai de vista. */
  function revealThumb(i) {
    var thumbs = $('#Pp2Thumbs');
    if (!thumbs) return;
    var btn = thumbs.children[i];
    if (!btn) return;
    var alvo = btn.offsetLeft - (thumbs.clientWidth - btn.offsetWidth) / 2;
    alvo = Math.max(0, Math.min(thumbs.scrollWidth - thumbs.clientWidth, alvo));
    if (Math.abs(thumbs.scrollLeft - alvo) < 2) return;
    scrollX(thumbs, alvo, false);
  }

  /* O player so nasce quando o scroll PARA no slide do video. Montar um <iframe>
     do YouTube durante o arrasto engasga exatamente o quadro que precisa ser
     liso, e so passar por cima de um video a caminho de outra foto nao deve
     baixar nada. */
  function mountVideo(i) {
    var track = $('#Pp2Track');
    if (!track) return;

    $all('.p-slide__vid', track).forEach(function (box) {
      var k = parseInt(box.getAttribute('data-i'), 10);
      if (k === i || box.getAttribute('data-on') !== '1') return;
      var vid = box.querySelector('video');
      if (vid) { vid.pause(); return; }
      // Embed de terceiro (YouTube/Vimeo, com autoplay=1 na propria URL): sem a
      // API deles nao da pra pausar de fora, entao desmontamos. Sem isto o audio
      // continua tocando com a foto de outro slide na tela.
      empty(box);
      fillPoster(box, GAL.media[k]);
    });

    var m = GAL.media[i];
    if (!m || (m.type !== 'video' && m.type !== 'external_video')) return;
    var host = track.querySelector('.p-slide__vid[data-i="' + i + '"]');
    if (!host || host.getAttribute('data-on') === '1') return;
    host.setAttribute('data-on', '1');
    empty(host);
    if (m.type === 'external_video') {
      host.appendChild(makeEl('iframe', {
        attrs: {
          src: m.embed,
          title: 'Vídeo do produto',
          allow: 'autoplay; encrypted-media; picture-in-picture',
          allowfullscreen: ''
        }
      }));
    } else {
      var videoEl = makeEl('video', { attrs: { controls: '', playsinline: '', poster: m.poster || '' } });
      videoEl.appendChild(makeEl('source', { attrs: { src: m.src, type: m.mime || 'video/mp4' } }));
      host.appendChild(videoEl);
    }
  }

  /* Fim do gesto: e aqui que a miniatura se centraliza e o video (se for o caso)
     e montado. Durante o arrasto so trocamos a miniatura acesa. */
  function onSettle() {
    var i = nearestSlide();
    state.img = i;
    GAL.target = null;
    paintThumbs(i);
    revealThumb(i);
    mountVideo(i);
  }

  function goToSlide(i, instant) {
    var track = $('#Pp2Track');
    if (!track) return;
    var w = track.clientWidth;
    // Sem layout ainda (secao fora de tela no editor): as miniaturas ja nascem
    // com a certa acesa em buildThumb, entao nao ha o que corrigir.
    if (!w) return;
    lastTrackW = w;
    var alvo = i * w;
    // Ja estamos la, ou o salto e instantaneo: nao vai vir evento de scroll, e
    // sem ele o settle (miniatura centralizada, video montado) nunca rodaria.
    if (Math.abs(track.scrollLeft - alvo) < 1) { onSettle(); return; }
    scrollX(track, alvo, instant);
    if (instant || !CAN_SMOOTH) onSettle();
  }

  function stepImage(delta) {
    var n = GAL.media.length;
    if (n < 2) return;
    // Parte do ALVO, nao de state.img: durante um scroll suave o state.img vai
    // passando pelos slides do caminho, e dois toques rapidos na seta contariam
    // a partir de um indice do meio do trajeto.
    var de = (GAL.target == null) ? state.img : GAL.target;
    selectImage((de + delta + n) % n);
  }

  function renderGalNav() {
    var prev = $('#Pp2GalPrev'), next = $('#Pp2GalNext');
    if (!prev || !next) return;
    var mostra = GAL.media.length > 1;
    prev.hidden = !mostra;
    next.hidden = !mostra;
  }

  function bindGalleryNav() {
    var prev = $('#Pp2GalPrev'), next = $('#Pp2GalNext'), track = $('#Pp2Track');
    if (prev) prev.addEventListener('click', function () { stepImage(-1); });
    if (next) next.addEventListener('click', function () { stepImage(1); });
    if (!track) return;

    track.addEventListener('scroll', function () {
      // Acende a miniatura JA durante o arrasto (uma vez por quadro): tira e foto
      // andam juntas, em vez de a miniatura dar um pulo so no fim do gesto.
      if (!scrollRaf) {
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          var i = nearestSlide();
          if (i !== state.img) { state.img = i; paintThumbs(i); }
        });
      }
      // "Parou de rolar" = 110ms sem evento novo. O evento scrollend resolveria
      // isto sozinho, mas ainda nao existe em todo Safari que a loja atende.
      clearTimeout(settleTimer);
      settleTimer = setTimeout(onSettle, 110);
    }, { passive: true });

    // Girar o aparelho muda a largura do slide, e a posicao guardada em pixels
    // deixa de bater. Re-ancora so quando a largura MUDOU: no celular o resize
    // dispara tambem quando a barra de endereco some (muda so a altura), e
    // reposicionar ali cortaria o gesto do cliente no meio.
    window.addEventListener('resize', function () {
      var t = $('#Pp2Track');
      if (!t) return;
      var w = t.clientWidth;
      if (!w || w === lastTrackW) return;
      lastTrackW = w;
      goToSlide(state.img, true);
    });
  }

  function selectImage(i) {
    if (!GAL.media[i]) return;
    state.img = i;
    GAL.target = i;
    paintThumbs(i);
    goToSlide(i, false);
  }

  function syncVariantImage() {
    // 1o refiltra a galeria pra variante; se a lista mudou, ela ja foi reconstruida
    // comecando na foto certa e nao ha o que pular.
    if (applyGalleryFilter()) return;
    var v = variant();
    if (!v || !v.featured_media_id) return;
    for (var i = 0; i < GAL.media.length; i++) {
      if (GAL.media[i].id === v.featured_media_id) { selectImage(i); return; }
    }
  }

  /* ---------- opcoes (pills / cards / select) ---------- */
  function repImageForValue(optIndex, value) {
    for (var i = 0; i < cfg.variants.length; i++) {
      var v = cfg.variants[i];
      if (v['option' + (optIndex + 1)] === value) return v.img;
    }
    return (cfg.media[0] && cfg.media[0].src) || '';
  }

  /* Plano que o painel usaria para ESTA variante (espelha freqEntry, que so olha a
     variante selecionada). Usado pelos selos das outras pills. */
  function planForVariant(v) {
    var pls = plansFor(v);
    if (!pls.length) return null;
    for (var i = 0; i < pls.length; i++) {
      if (pls[i].group === state.freq) return pls[i];
    }
    return pls[0];
  }

  /* Selos do seletor de variante (paridade com snippets/swatch-image.liquid do tema):
     "Esgotado" quando nenhuma variante daquele valor esta disponivel, senao "-N%".
     Esgotado tem PRIORIDADE sobre o desconto.

     Duas origens de desconto, de proposito separadas:
     - disc    = OFERTA REAL: metafield custom.discount, ou o compare_at (fallback
                 nosso). Vale nos dois modos de compra.
     - subDisc = DESCONTO DE ASSINATURA, tirado do PLANO (preco do plano vs preco
                 cheio). So aparece com a assinatura selecionada, porque so existe
                 nela. Vem do plano e nao de metafield justamente porque metafield e
                 preenchido a mao: nos Bites o Tubo tinha e o Refil nao, entao a
                 mesma promocao de 10% aparecia numa pill e sumia na outra. */
  function optionValueState(matches) {
    var avail = false, disc = 0, subDisc = 0;
    for (var i = 0; i < matches.length; i++) {
      if (matches[i].available) { avail = true; break; }
    }
    for (var j = 0; j < matches.length; j++) {
      var m = matches[j];
      if (avail && !m.available) continue;
      if (!disc) {
        if (m.disc > 0) disc = m.disc;
        else {
          var cmp = m.compare_at_price;
          if (typeof cmp === 'number' && cmp > m.price) {
            var pct = Math.round((1 - m.price / cmp) * 100);
            if (pct >= 1) disc = pct;
          }
        }
      }
      if (!subDisc) {
        var pl = planForVariant(m);
        if (pl && pl.price < m.price) {
          var spct = Math.round((1 - pl.price / m.price) * 100);
          if (spct >= 1) subDisc = spct;
        }
      }
      if (disc && subDisc) break;
    }
    return { available: avail, disc: disc, subDisc: subDisc };
  }

  /* Pinta o botao de um valor de opcao: selo + foto esmaecida quando esgotado.
     IDEMPOTENTE: limpa o selo anterior antes, porque agora isto roda a cada render
     (o selo de assinatura muda quando o cliente alterna o modo de compra). */
  function decorateOptionButton(btn, matches) {
    var st = optionValueState(matches);
    btn.classList.toggle('is-soldout', !st.available);
    var velho = btn.querySelector('.p-vbadge');
    if (velho) btn.removeChild(velho);
    btn.classList.remove('has-vbadge');
    var badge = null;
    if (!st.available) {
      badge = makeEl('span', { className: 'p-vbadge p-vbadge--sold', text: 'Esgotado' });
    } else if (subAtivo() && st.subDisc > 0) {
      badge = makeEl('span', { className: 'p-vbadge p-vbadge--disc', text: '-' + st.subDisc + '%' });
    } else if (st.disc > 0) {
      badge = makeEl('span', { className: 'p-vbadge p-vbadge--disc', text: '-' + st.disc + '%' });
    }
    if (!badge) return;
    // Selo pequeno no canto superior direito. A classe has-vbadge reserva um respiro
    // no topo do botao pra o rotulo (centralizado) nunca encostar no selo.
    btn.classList.add('has-vbadge');
    btn.appendChild(badge);
  }

  /* As pills da opcao 1 sao montadas UMA vez; os cards da opcao 2 ja se refazem a
     cada render. Como o selo de assinatura depende do modo de compra selecionado,
     repintamos as pills aqui a cada render (decorateOptionButton e idempotente). */
  function refreshOptionBadges() {
    var box = $('#Pp2Opt1');
    if (!box) return;
    $all('.p-grao', box).forEach(function (b) {
      var val = b.getAttribute('data-opt1');
      if (val != null) decorateOptionButton(b, variantsForOption(0, val));
    });
  }

  /* v4: rotulo da variante selecionada, abaixo da fileira de fotos. Vive no render
     (e nao so no clique) porque a variante tambem muda pela barra fixa e pelo
     select da 3a opcao, que nao passam pelo clique da pill. */
  // O rotulo unico embaixo da fileira saiu: cada foto passou a levar o proprio
  // nome. A funcao fica com a guarda porque render() a chama e o elemento pode
  // reaparecer se alguem reintroduzir o rotulo.
  function refreshOptName() {
    var el = $('#Pp2OptName');
    if (el) el.textContent = state.opt[0] == null ? '' : state.opt[0];
  }

  function variantsForOption(optIndex, value) {
    var out = [];
    for (var i = 0; i < cfg.variants.length; i++) {
      if (cfg.variants[i]['option' + (optIndex + 1)] === value) out.push(cfg.variants[i]);
    }
    return out;
  }

  function buildOptionPickers() {
    var wrap = $('#Pp2Options');
    if (!wrap) return;
    if (optionCount === 0) { wrap.hidden = true; return; }
    empty(wrap);

    var opt1 = cfg.options[0];
    var field1 = makeEl('div', { className: 'p-field' });
    field1.appendChild(makeEl('span', { className: 'p-label', text: opt1.name }));
    var pillsBox = makeEl('div', { attrs: { id: 'Pp2Opt1', role: 'radiogroup', 'aria-label': opt1.name }, className: 'p-graos' });
    /* Esgotado vai pro FIM da fileira: o cliente encontra primeiro o que da pra
       comprar. Sort ESTAVEL (ES2019+), entao a ordem curada no admin e preservada
       dentro de cada grupo: os disponiveis mantem a ordem entre si e os esgotados
       tambem. Ordena uma copia, nao o cfg, que e lido por variantsForOption e pelo
       resto do painel. */
    var valoresOrdenados = opt1.values.slice().sort(function (a, b) {
      var da = optionValueState(variantsForOption(0, a)).available ? 0 : 1;
      var db = optionValueState(variantsForOption(0, b)).available ? 0 : 1;
      return da - db;
    });
    valoresOrdenados.forEach(function (val) {
      // O nome fica EMBAIXO DA FOTO, dentro do proprio botao (pedido do Mario,
      // 1/ago). A v4 tinha tirado o nome daqui e deixado um rotulo unico embaixo
      // da fileira, que so dizia qual estava selecionado: para saber o nome dos
      // outros era preciso clicar em cada um. E o seletor da opcao 2, logo abaixo,
      // sempre mostrou o nome sob cada foto, entao os dois viviam diferentes na
      // mesma tela.
      var b = makeEl('button', {
        className: 'p-grao' + (state.opt[0] === val ? ' is-on' : ''),
        attrs: { type: 'button', 'data-opt1': val, 'aria-label': val }
      });
      b.appendChild(makeImg(repImageForValue(0, val), 100, 100));
      b.appendChild(makeEl('span', { text: val }));
      decorateOptionButton(b, variantsForOption(0, val));
      b.addEventListener('click', function () {
        state.opt[0] = val;
        $all('.p-grao', pillsBox).forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-opt1') === val); });
        syncVariantImage();
        render();
      });
      pillsBox.appendChild(b);
    });
    field1.appendChild(pillsBox);
    wrap.appendChild(field1);

    if (optionCount >= 2) {
      var opt2 = cfg.options[1];
      var field2 = makeEl('div', { className: 'p-field' });
      field2.appendChild(makeEl('span', { className: 'p-label', text: opt2.name }));
      field2.appendChild(makeEl('div', { attrs: { id: 'Pp2Opt2', role: 'radiogroup', 'aria-label': opt2.name }, className: 'p-sizes' }));
      wrap.appendChild(field2);
    }

    if (optionCount >= 3) {
      var opt3 = cfg.options[2];
      var field3 = makeEl('div', { className: 'p-field' });
      field3.appendChild(makeEl('span', { className: 'p-label', text: opt3.name }));
      var sel3 = makeEl('select', { attrs: { id: 'Pp2Opt3', 'aria-label': opt3.name }, className: 'p-opt__freqsel' });
      opt3.values.forEach(function (val) {
        sel3.appendChild(makeEl('option', { attrs: { value: val }, text: val }));
      });
      sel3.value = state.opt[2] || opt3.values[0];
      sel3.addEventListener('change', function () {
        state.opt[2] = sel3.value;
        render();
      });
      field3.appendChild(sel3);
      wrap.appendChild(field3);
    }
  }

  function renderOption2Cards() {
    if (optionCount < 2) return;
    var box = $('#Pp2Opt2');
    if (!box) return;
    empty(box);
    var opt2 = cfg.options[1];
    opt2.values.forEach(function (val) {
      var matches = cfg.variants.filter(function (v) {
        var okOpt1 = state.opt[0] == null || v.option1 === state.opt[0];
        return okOpt1 && v.option2 === val;
      });
      if (!matches.length) return;
      var b = makeEl('button', { className: 'p-size' + (state.opt[1] === val ? ' is-on' : ''), attrs: { type: 'button' } });
      b.appendChild(makeImg(matches[0].img, 120, 120));
      b.appendChild(makeEl('span', { text: val }));
      decorateOptionButton(b, matches);
      b.addEventListener('click', function () {
        state.opt[1] = val;
        syncVariantImage();
        render();
      });
      box.appendChild(b);
    });
  }

  /* ---------- render principal ---------- */
  function render() {
    // rede de seguranca: qualquer caminho que troque de variante (pills, cards,
    // select da 3a opcao, barra fixa) passa por aqui, entao a galeria nunca fica
    // exibindo as fotos de outra cor. No-op quando a lista ja e a certa.
    applyGalleryFilter();
    renderOption2Cards();
    refreshOptionBadges();
    refreshOptName();

    var v = variant();
    var variantIdField = $('#Pp2VariantIdField');
    if (variantIdField) variantIdField.value = v.id;

    var oncePrice = $('#Pp2OncePrice');
    if (oncePrice) oncePrice.textContent = money(v.price);

    var pl = nativePlan();
    var hasSub = !!(pl && cfg.show_sub);
    var optSub = $('#Pp2OptSub'), optOnce = $('#Pp2OptOnce');

    if (hasSub) {
      if (optSub) optSub.style.display = '';
      var pct = v.price > 0 ? Math.round((1 - pl.price / v.price) * 100) : 0;
      var savePct = $('#Pp2SavePct'); if (savePct) savePct.textContent = pct + '%';
      var subCompare = $('#Pp2SubCompare'); if (subCompare) subCompare.textContent = money(v.price);
      var subPrice = $('#Pp2SubPrice'); if (subPrice) subPrice.textContent = money(pl.price);
    } else if (optSub) {
      optSub.style.display = 'none';
    }

    var sub = state.sub && hasSub;
    if (optSub) optSub.classList.toggle('is-on', sub);
    if (optOnce) optOnce.classList.toggle('is-on', !sub);

    var priceCompare = $('#Pp2Compare'), priceEl = $('#Pp2Price'), priceNote = $('#Pp2PriceNote');
    var saleBadge = $('#Pp2SaleBadge');
    if (priceNote) priceNote.hidden = !sub;
    if (sub) {
      // assinatura: riscado = preco de lista da variante, sem selo de oferta
      if (priceCompare) { priceCompare.textContent = money(v.price); priceCompare.hidden = false; }
      if (saleBadge) saleBadge.hidden = true;
      if (priceEl) priceEl.textContent = money(pl.price);
    } else {
      // compra unica: mostra o compare-at do proprio catalogo (produto em oferta)
      if (priceEl) priceEl.textContent = money(v.price);
      var sale = saleInfo(v);
      if (priceCompare) {
        if (sale.onSale) { priceCompare.textContent = money(sale.cmp); priceCompare.hidden = false; }
        else { priceCompare.hidden = true; }
      }
      if (saleBadge) {
        if (sale.onSale) {
          saleBadge.textContent = '−' + sale.pct + '%';
          saleBadge.hidden = false;
        } else {
          saleBadge.hidden = true;
        }
      }
    }

    var freqSel = $('#Pp2Freq');
    if (freqSel && hasSub) {
      var vKey = String(v.id);
      if (freqSel.getAttribute('data-key') !== vKey) {
        freqSel.setAttribute('data-key', vKey);
        empty(freqSel);
        plansFor(v).forEach(function (p) {
          freqSel.appendChild(makeEl('option', { attrs: { value: p.group }, text: friendlyFreqLabel(p) }));
        });
        var opts = freqSel.options;
        var hasCurrent = false;
        for (var fi = 0; fi < opts.length; fi++) { if (opts[fi].value === state.freq) hasCurrent = true; }
        if (!hasCurrent && opts.length) state.freq = opts[0].value;
      }
      freqSel.value = state.freq;
    }

    var fe = freqEntry();
    var per = '/mês';
    if (fe) {
      var lbl = friendlyFreqLabel(fe).toLowerCase();
      if (lbl.indexOf('15 dias') !== -1) per = '/15 dias';
      else if (lbl.indexOf('45 dias') !== -1) per = '/45 dias';
      else if (lbl.indexOf('2 meses') !== -1) per = '/2 meses';
      else if (lbl.indexOf('3 meses') !== -1) per = '/3 meses';
    }
    var subPer = $('#Pp2SubPer'); if (subPer) subPer.textContent = per;
    if (priceNote) priceNote.textContent = per;

    renderCta(v);
    renderStickybar(v, sub, pl, per);
    applyKoinCashback();
    renderNotify(v);
    renderStock(v);
    renderVolume(v, sub);
    // A elegibilidade do volume pode devolver a quantidade a 1. Sincronizar
    // depois dela tambem atualiza corretamente os limites do stepper.
    renderQuantity();
    renderCombo(sub);
    renderInstallment(v, sub);
    renderShipinfo(v);
    // A barra foi calculada para a variante e a quantidade daquele momento. Mudou
    // qualquer um dos dois, o numero na tela virou mentira: escondemos em vez de
    // deixar "faltam R$ 280,10" enquanto o carrinho projetado ja passou do limiar.
    invalidateShippingProjection();
  }

  /* ---------- frete: frase sobre ESTE produto ----------
     Espelha as frases do Liquid em sections/product-page-v2.liquid. Precisa existir
     aqui porque o preco muda com a variante e a resposta muda junto: uma variante de
     R$ 280 e outra de R$ 320 dizem coisas diferentes sobre frete gratis.

     ATENCAO: isto e PROJECAO, baseada nos limiares configurados na secao. A regra
     real vive no FreteFlow. Quem manda de verdade e a cotacao, e por isso a caixa
     de resultado (pintada pelo modulo, em frete-cotacao.js) sobrescreve tudo
     quando a tarifa volta com preco zero. */
  function montaFrase(el, partes) {
    if (!el) return;
    el.replaceChildren();
    partes.forEach(function (p) {
      if (p.b) el.appendChild(makeEl('strong', { text: p.b }));
      else if (p.nota) el.appendChild(makeEl('span', { className: 'p-shipinfo__nota', text: p.nota }));
      else el.appendChild(document.createTextNode(p.t));
    });
  }

  /* Gemeo em JS do bloco Liquid da secao: as frases precisam ser IDENTICAS, senao
     trocar de variante reescreve o texto com outra redacao.

     "SP capital e Grande SP", e nunca so "Sao Paulo": o corte do beneficio e o CEP
     0xxxx, entao quem esta em Campinas ou Santos esta no estado de Sao Paulo e NAO
     tem frete gratis, tem desconto. Dizer "Sao Paulo" fazia essa pessoa esperar
     gratuidade e descobrir o contrario so no checkout.

     A excecao por SKU das torres Egeo saiu junto com a regra de R$ 600: elas agora
     entram no desconto como qualquer outro produto. */
  function renderShipinfo(v) {
    var el = $('#Pp2ShipInfo'), f = cfg.frete;
    if (!el || !f || !v) return;
    montaFrase(el, v.price >= f.sp
      ? [{ t: 'Este produto tem ' }, { b: 'frete grátis' },
         { t: ' em SP capital e Grande SP, e frete com desconto no resto do Brasil.' }]
      : [{ t: 'A partir de ' }, { b: money(f.sp) },
         { t: ' seu frete tem desconto. Em SP capital e Grande SP, é grátis.' }]);
  }

  /* ---------- contador de estoque (scarcity) ----------
     Paridade com o bloco "inventory" do template antigo: mostra "So N em estoque"
     quando a variante tem estoque gerenciado (inv_managed) e baixo (1..LIMIT). */
  function renderStock(v) {
    var el = $('#Pp2Stock');
    if (!el) return;
    // Era 10. Mario: "se tiver 6 ou mais nao precisa mostrar quantas unidades
    // restam". Com 10 o aviso aparecia cedo demais e virava ruido em vez de
    // urgencia. Agora so a partir de 5 pra baixo.
    var LIMIT = 5;
    var qty = v.inv_qty;
    if (v.available && v.inv_managed && typeof qty === 'number' && qty > 0 && qty <= LIMIT) {
      el.textContent = qty === 1 ? 'Só 1 em estoque' : 'Só ' + qty + ' em estoque';
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  /* ---------- parcelamento (recalculo por variante) ----------
     O snippet 'installment' renderiza o estado inicial no Liquid (e nao renderiza nada
     em produto de assinatura). O <script> dele le .price-item (classe do Dawn) que a v2
     nao tem, entao aqui refazemos a conta com o preco da variante atual, usando os mesmos
     parametros: settings de parcelamento (cfg.parcel) + tabela de coeficientes do
     Mercado Pago "parcelado cliente". Guardado: sem o bloco no DOM, no-op.
     ATENCAO: esta tabela de coeficientes tambem existe em snippets/installment.liquid
     (no Liquid e no <script> dele). Mudou a taxa la, mude aqui tambem. */
  var MP_COEFS = [0, 1, 1.0964, 1.1123, 1.1136, 1.1431, 1.1432, 1.1672, 1.1673, 1.1969, 1.2065, 1.2066, 1.2211];
  var MIN_PARCEL_JUROS = 500;

  function renderInstallment(v, sub) {
    var wrap = $('.price-installment');
    if (!wrap || !cfg.parcel) return;
    var price = sub ? 0 : v.price;
    if (!price) return;
    var qtdMax = cfg.parcel.qtd || 1;
    var minParcel = cfg.parcel.min || 0;

    // ATENCAO: o Liquid usa divisao INTEIRA (`| divided_by:`) na parcela sem juros
    // (59990/4 = 14997 => R$ 149,97). Usar Math.round aqui daria 149,98 e o numero
    // mudaria sozinho no primeiro render() do JS. Math.floor casa com o Liquid.
    var semQtd = 1, semVal = price;
    for (var i = qtdMax; i >= 1; i--) {
      var parcela = Math.floor(price / i);
      if (parcela >= minParcel) { semQtd = i; semVal = parcela; break; }
    }
    var comQtd = 0, comVal = 0;
    for (var n = 12; n >= 1; n--) {
      var p = Math.round(price * MP_COEFS[n] / n);
      if (p >= MIN_PARCEL_JUROS) { comQtd = n; comVal = p; break; }
    }
    var hasCom = comQtd > semQtd;

    var semEl = wrap.querySelector('.price__parcel');
    if (semEl) semEl.textContent = '(até ' + semQtd + 'x de ' + money(semVal) + ' sem juros' + (hasCom ? '' : ')');
    var jurosEl = wrap.querySelector('.price__parcel--juros');
    if (hasCom) {
      if (!jurosEl) {
        jurosEl = makeEl('div', { className: 'price__parcel price__parcel--juros' });
        wrap.appendChild(jurosEl);
      }
      jurosEl.textContent = 'ou até ' + comQtd + 'x de ' + money(comVal) + ' com juros)';
    } else if (jurosEl) {
      jurosEl.parentNode.removeChild(jurosEl);
    }
  }

  /* ---------- desconto por volume (1 nivel, so compra unica) ----------
     Porta o desconto por volume nativo (ja existe no template product.combo) pro painel
     da v2/v3. O checkbox ajusta state.qty pro nivel (min_qty); o desconto real e um
     desconto automatico nativo do Shopify. A logica mora AQUI (dona do state.qty) porque
     o add-to-cart le state.qty, nao o campo [name=quantity]. Aparece so na compra unica
     (sub=false) e so se a variante tem estoque >= min_qty. */
  function renderVolume(v, sub) {
    var box = $('#Pp2Vol');
    if (!box) return;
    var vol = cfg.volume;
    var cb = $('#Pp2VolCb');
    var eligible = !!vol && !sub && v.available &&
      (!v.inv_managed || (typeof v.inv_qty === 'number' && v.inv_qty >= vol.min_qty));
    if (!eligible) {
      if (cb && cb.checked) {
        cb.checked = false;
        state.qty = 1;
      }
      box.hidden = true;
      return;
    }
    var full = v.price * vol.min_qty;
    var save = Math.round(full * vol.pct / 100);
    var deal = full - save;
    var fullEl = $('#Pp2VolFull'); if (fullEl) fullEl.textContent = money(full);
    var dealEl = $('#Pp2VolDeal'); if (dealEl) dealEl.textContent = money(deal);
    var saveEl = $('#Pp2VolSave'); if (saveEl) saveEl.textContent = money(save);
    // coerencia: se o cliente mexeu no stepper e saiu do nivel, desmarca (mantem a qty dele).
    if (cb && cb.checked && state.qty !== vol.min_qty) cb.checked = false;
    box.hidden = false;
  }

  /* ---------- combo "compre junto" (visibilidade) ----------
     A UI vem do snippet 'combo-addon' (metafields custom.combo_addon(s)); aqui so
     cuidamos de QUANDO ela vale. Os add-ons so entram na COMPRA UNICA: a guarda de
     assinatura desfaz apenas items[0], entao mandar add-on junto de uma assinatura
     que falha deixaria linha orfa no carrinho. Como o doAddToCart ignora os add-ons
     na assinatura, deixar os checkboxes visiveis ali seria pior: o cliente marcaria e
     o item sumiria sem aviso. Mesma politica do bloco de volume: esconde e desmarca. */
  function renderCombo(sub) {
    var box = $('[data-wl-combo]');
    if (!box) return;
    if (sub) {
      $all('[data-wl-combo-cb]').forEach(function (cb) { cb.checked = false; });
      box.hidden = true;
    } else {
      box.hidden = false;
    }
  }

  /* ---------- botao "Avise-me" (variante esgotada) ----------
     A loja usa o app Restock Rocket (Stoq) so em modo flutuante, que a v2 esconde.
     Mostramos um botao inline abaixo do CTA quando a variante esta esgotada; o clique
     dispara o botao real do app (proxy-click), que abre o form de cadastro dele. O app
     detecta a variante selecionada pelo input [name="id"] (que render() mantem em dia). */
  function renderNotify(v) {
    var notify = $('#Pp2Notify');
    if (!notify) return;
    notify.hidden = !!v.available;
  }

  function bindNotify() {
    var notify = $('#Pp2Notify');
    if (!notify) return;
    try {
      var rr = window._RestockRocketConfig || window._StoqConfig;
      var txt = rr && rr.settings && rr.settings.storefront_button_text;
      var lbl = notify.querySelector('.p-notify__label');
      if (txt && lbl) lbl.textContent = txt;
    } catch (e) {}
    notify.addEventListener('click', function () {
      var appBtn = document.querySelector('.restock-rocket-button-product.restock-rocket-button-float')
        || document.querySelector('.restock-rocket-button-container-float-right button')
        || document.querySelector('.restock-rocket-button-product');
      if (appBtn) appBtn.click();
    });
  }

  function bindVolume() {
    var cb = $('#Pp2VolCb');
    if (!cb) return;
    cb.addEventListener('change', function () {
      var min = cfg.volume && cfg.volume.min_qty;
      state.qty = (cb.checked && min) ? min : 1;
      renderQuantity();
      invalidateShippingProjection();
    });
  }

  /* ---------- cashback do Koin sincronizado com o plano ----------
     O widget do Koin estima o cashback lendo o preco da VARIANTE (nao do selling
     plan); como assinatura e compra unica sao a mesma variante, ele mostra sempre
     3% do preco de lista. Aqui recalculamos com a PROPRIA taxa configurada no Koin
     (window._Koin, programa order-based) sobre o preco efetivo selecionado, pra o
     numero acompanhar a escolha (assinatura = preco menor = cashback menor). Tudo
     guardado: se o app/config/DOM nao existir, nao faz nada (nunca quebra). */
  function koinRewardRate() {
    var k = window._Koin;
    if (!k || !k.entries || !k.entries.length) return null;
    for (var i = 0; i < k.entries.length; i++) {
      var e = k.entries[i];
      if (e && e.type === 'order-based' && e.status && e.reward_setting &&
          e.reward_setting.reward_type === 'percentage') {
        var r = parseFloat(e.reward_setting.reward_value);
        if (r > 0) return r / 100;
      }
    }
    return null;
  }

  function applyKoinCashback() {
    var rate = koinRewardRate();
    if (rate == null) return;
    var strong = document.querySelector('.koin-promotion-widget__description strong, .koin-promotion-widget strong');
    if (!strong) return;
    var v = variant();
    var pl = nativePlan();
    var sub = subAtivo();
    var cents = Math.round((sub ? pl.price : v.price) * rate);
    var target = money(cents);
    if (strong.textContent.trim() !== target) strong.textContent = target;
  }

  function initKoinSync() {
    if (koinRewardRate() == null) { return false; }
    var host = document.querySelector('.koin-promotion-widget');
    if (!host) return false;
    // o Koin re-renderiza no change do form (nossa troca de plano dispara isso e
    // ele reescreve o valor de lista); um observer reaplica nosso valor por cima.
    if ('MutationObserver' in window) {
      new MutationObserver(function () { applyKoinCashback(); })
        .observe(host, { childList: true, subtree: true, characterData: true });
    }
    applyKoinCashback();
    return true;
  }

  function ctaLabel(v) {
    if (!v.available) {
      return { text: cfg.preorder_unavailable || 'Esgotado', disabled: true };
    }
    /* Pre-venda do STOQ manda no rotulo e trava o botao ate o aceite. Vem ANTES do
       caminho legado (cfg.preorder_available, dois metafields de produto que so
       trocam texto e nao conhecem aceite), senao o legado venceria e o cliente
       compraria sem aceitar o prazo. */
    if (preVendaAtiva()) {
      return { text: cfg.pre_venda_botao || 'Adicionar ao carrinho', disabled: !aceiteOk() };
    }
    if (cfg.preorder_available) {
      return { text: cfg.preorder_available, disabled: false };
    }
    // sub EFETIVO (nao o state.sub cru): so "Assinar" quando o produto realmente tem
    // plano de assinatura. Em produto sem assinatura, state.sub fica true por default
    // (sem cards pra desmarcar), entao o rotulo tem que olhar cfg.show_sub + plano.
    var pl = nativePlan();
    var sub = subAtivo();
    return { text: sub ? 'Assinar e economizar' : 'Adicionar ao carrinho', disabled: false };
  }

  function renderCta(v) {
    /* Aviso de reposicao: so com a variante esgotada. O texto ("Volta em breve,
       data estimada ...") mentiria num item a venda. Fica aqui junto do CTA porque
       os dois dependem da mesma coisa, a disponibilidade da variante. */
    var reposicao = $('#Pp2Reposicao');
    if (reposicao) reposicao.hidden = !!v.available;

    var cta = $('#Pp2Cta');
    if (!cta) return;
    var info = ctaLabel(v);
    var label = cta.querySelector('.p-cta__label');
    if (label && !cta.hasAttribute('data-busy')) label.textContent = info.text;
    if (info.disabled) cta.setAttribute('disabled', ''); else cta.removeAttribute('disabled');
  }

  /* Marcar o aceite repinta o CTA na hora. Delegacao no document porque o bloco de
     pre-venda e Liquid: ele existe desde o primeiro render e nao e recriado, mas a
     delegacao custa nada e sobrevive se um dia passar a ser. */
  document.addEventListener('change', function (e) {
    var alvo = e.target;
    if (!alvo || alvo.id !== 'Pp2PrevAceite') return;
    renderCta(variant());
  });

  function renderStickybar(v, sub, pl, per) {
    var bar = $('#Pp2Sticky');
    if (!bar) return;
    var stkCompare = $('#StkCompare'), stkPrice = $('#StkPrice'), stkNote = $('#StkNote');
    if (stkNote) { stkNote.hidden = !sub; stkNote.textContent = per; }
    if (sub) {
      if (stkCompare) { stkCompare.textContent = money(v.price); stkCompare.hidden = false; }
      if (stkPrice) stkPrice.textContent = money(pl.price);
    } else {
      if (stkPrice) stkPrice.textContent = money(v.price);
      // espelha a oferta do painel (mesmo saleInfo): sem isso a barra fixa mostrava so
      // o preco final enquanto o painel mostrava o riscado + selo.
      var stkSale = saleInfo(v);
      if (stkCompare) {
        if (stkSale.onSale) { stkCompare.textContent = money(stkSale.cmp); stkCompare.hidden = false; }
        else { stkCompare.hidden = true; }
      }
    }
    var stkCta = $('#StkCta');
    if (stkCta) {
      var info = ctaLabel(v);
      var lbl = stkCta.querySelector('.p-cta__label');
      if (lbl && !stkCta.hasAttribute('data-busy')) lbl.textContent = info.text;
      if (info.disabled) stkCta.setAttribute('disabled', ''); else stkCta.removeAttribute('disabled');
    }
  }

  /* ---------- feedback tatil dos botoes de quantidade ----------
     Mario, video de 08/ago: "ao clique do usuario nao da pra saber se o botao foi
     apertado, e so da pra saber segundos depois quando o numero muda".

     Medido no proprio video (quadros a 10fps): o numero troca em menos de 100ms,
     entao nao ha lentidao de verdade. O que falta e RESPOSTA AO TOQUE. O botao
     nao tinha estado apertado nenhum: o reset da secao zera o tap highlight do
     iOS e nao havia :active, entao o unico sinal de que o toque pegou era o
     digito virar — e o clique so resolve quando o dedo LEVANTA. Encostar e nao
     ver nada acontecer e o que se sente como travamento.

     A resposta vem em tres camadas, da mais confiavel pra menos:
       1. visual, no pointerdown (CSS .is-press) — funciona em todo aparelho;
       2. o numero pulsando na troca (.is-bump);
       3. vibracao, onde o navegador deixa.

     Sobre a vibracao: navigator.vibrate e Android/Chrome. O Safari do iPhone NAO
     expoe vibracao pra pagina, e nao ha API que resolva. O que existe no iOS
     (17.4+) e um efeito colateral do proprio sistema: alternar um <input
     type="checkbox" switch> toca o "tick" haptico nativo. Entao mantemos um
     switch de 1px fora de vista e clicamos nele dentro do gesto do cliente.
     E gambiarra e pode parar de valer numa versao futura do iOS — por isso ela
     e a TERCEIRA camada, reforco, e nunca o mecanismo principal. Tudo dentro de
     try/catch: se falhar, o cliente ainda ve o botao afundar. */
  var hapticSwitch;

  function hapticTap() {
    try {
      if (navigator.vibrate) { navigator.vibrate(10); return; }
      // O switch precisa estar RENDERIZADO pra o iOS tocar o haptico: display:none
      // ou visibility:hidden matam o efeito. Por isso ele fica 1px transparente
      // fora do fluxo, e nao escondido.
      if (hapticSwitch === undefined) {
        hapticSwitch = null;
        if ('switch' in document.createElement('input')) {
          var wrap = makeEl('label', { attrs: { 'aria-hidden': 'true' } });
          wrap.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;overflow:hidden;';
          var inp = makeEl('input', { attrs: { type: 'checkbox', switch: '', tabindex: '-1' } });
          wrap.appendChild(inp);
          root.appendChild(wrap);
          hapticSwitch = wrap;
        }
      }
      if (hapticSwitch) hapticSwitch.click();
    } catch (e) { /* feedback e enfeite: nunca pode derrubar o botao de compra */ }
  }

  /* Pinta o "apertado" e dispara o haptico no instante do ENCOSTO, antes de
     qualquer logica — nao no clique, que so resolve quando o dedo levanta. A
     classe sai no pointerup/cancel; num toque rapido o dedo sai antes de a tela
     pintar, entao seguramos a marca por 90ms pra ela chegar a ser vista. */
  function bindPressFeedback(b) {
    var t0 = 0, timer = 0;
    function press() {
      clearTimeout(timer);
      t0 = Date.now();
      b.classList.add('is-press');
      hapticTap();
    }
    function release() {
      clearTimeout(timer);
      var falta = 90 - (Date.now() - t0);
      if (falta > 0) timer = setTimeout(function () { b.classList.remove('is-press'); }, falta);
      else b.classList.remove('is-press');
    }
    if (window.PointerEvent) {
      b.addEventListener('pointerdown', press);
      b.addEventListener('pointerup', release);
      b.addEventListener('pointercancel', release);
      b.addEventListener('pointerleave', release);
    } else {
      b.addEventListener('touchstart', press, { passive: true });
      b.addEventListener('touchend', release);
      b.addEventListener('touchcancel', release);
      b.addEventListener('mousedown', press);
      b.addEventListener('mouseup', release);
      b.addEventListener('mouseleave', release);
    }
  }

  /* Apaga o - no 1 e o + no 99. Sem isto o toque na ponta da faixa nao muda nada
     e o cliente fica sem saber se o botao respondeu ou se a pagina travou. */
  function paintQtyBounds() {
    $all('.p-qty button').forEach(function (b) {
      var delta = parseInt(b.getAttribute('data-q'), 10) || 0;
      var travado = (delta < 0 && state.qty <= 1) || (delta > 0 && state.qty >= 99);
      b.classList.toggle('is-off', travado);
      b.setAttribute('aria-disabled', travado ? 'true' : 'false');
    });
  }

  /* Quantidade nao muda variante, plano ou precos UNITARIOS. Seu caminho
     atualiza apenas o stepper e a coerencia do volume; nao recria opcoes,
     galeria, parcelamento nem widgets de apps. O campo usado no add/frete
     acompanha state.qty na mesma tarefa, inclusive antes do proximo quadro. */
  function renderQuantity() {
    var out = $('#Pp2Qty');
    if (out && out.textContent !== String(state.qty)) out.textContent = state.qty;
    var field = $('#Pp2QtyField');
    if (field && field.value !== String(state.qty)) field.value = state.qty;
    paintQtyBounds();
    var cb = $('#Pp2VolCb'), vol = cfg.volume;
    if (cb && cb.checked && vol && state.qty !== vol.min_qty) cb.checked = false;
  }

  function invalidateShippingProjection() {
    var metaBox = $('#Pp2FreteMeta');
    if (metaBox) metaBox.hidden = true;
  }

  var quantityPaintPending = false;
  function scheduleQuantityPaint() {
    if (quantityPaintPending) return;
    quantityPaintPending = true;
    requestAnimationFrame(function () {
      quantityPaintPending = false;
      var out = $('#Pp2Qty');
      if (!out) return;
      // Dois nomes de animacao equivalentes reiniciam o pulso sem ler layout.
      // Cliques no mesmo quadro se juntam, mas todos contam em state.qty.
      var again = out.classList.contains('is-bump');
      out.classList.toggle('is-bump', !again);
      out.classList.toggle('is-bump-again', again);
    });
  }

  function bumpQty() {
    renderQuantity();
    invalidateShippingProjection();
    scheduleQuantityPaint();
  }

  /* ---------- eventos fixos ---------- */
  function bindStaticEvents() {
    $all('.p-qty button').forEach(function (b) {
      bindPressFeedback(b);
      b.addEventListener('click', function () {
        var delta = parseInt(b.getAttribute('data-q'), 10) || 0;
        var novo = Math.max(1, Math.min(99, state.qty + delta));
        if (novo === state.qty) return;   // na ponta da faixa: o is-off ja explicou
        state.qty = novo;
        bumpQty();
      });
    });
    paintQtyBounds();

    var optSub = $('#Pp2OptSub'), optOnce = $('#Pp2OptOnce'), freqSel = $('#Pp2Freq');
    if (optOnce) optOnce.addEventListener('click', function () { state.sub = false; render(); });
    if (optSub) {
      optSub.addEventListener('click', function (e) {
        if (e.target && e.target.id === 'Pp2Freq') return;
        state.sub = true; render();
      });
    }
    if (freqSel) {
      freqSel.addEventListener('click', function (e) { e.stopPropagation(); });
      freqSel.addEventListener('change', function (e) {
        e.stopPropagation();
        state.freq = this.value; state.sub = true; render();
      });
    }

    var cta = $('#Pp2Cta'); if (cta) cta.addEventListener('click', function () { doAddToCart(this); });
    var stkCta = $('#StkCta'); if (stkCta) stkCta.addEventListener('click', function () { doAddToCart(this); });
  }

  /*
   * TRANSPORTE DE CARRINHO IMUNE AO INTERCEPTADOR DO APPSTLE.
   *
   * O script do Appstle (appstle-subscription.min.js) sobrescreve window.fetch e
   * reescreve toda chamada a /cart/add a partir do widget DELE no DOM:
   *   jQuery('.appstle_sub_widget input[name=selling_plan]:checked').val()
   * Esta pagina tem painel proprio e NAO renderiza o widget do Appstle, entao o
   * interceptador nao acha radio marcado nenhum e DESCARTA o selling_plan que
   * mandamos: o item entra a preco cheio, HTTP 200, sem erro nenhum.
   *
   * Provado em 26/jul/2026 na Racao Castrados (variante 48701788684531, plano
   * 6426427635), mesma pagina e mesma execucao: via window.fetch entra R$69,90
   * SEM plano; via XMLHttpRequest entra R$62,91 COM plano; injetando um
   * .appstle_sub_widget oculto com o radio marcado, o MESMO window.fetch volta a
   * aplicar. Ou seja: o problema nunca foi a config dos planos no Appstle.
   *
   * Solucao: pegar um fetch virgem de um iframe same-origin (o Appstle patcheia
   * so o window desta pagina). O iframe FICA no DOM de proposito, porque remove-lo
   * neutraliza o contentWindow em alguns navegadores.
   */
  var _pristineFetch = null;
  function pristineFetch() {
    if (_pristineFetch) return _pristineFetch;
    try {
      var fr = document.createElement('iframe');
      fr.setAttribute('aria-hidden', 'true');
      fr.setAttribute('tabindex', '-1');
      fr.setAttribute('title', '');
      fr.style.display = 'none';
      document.documentElement.appendChild(fr);
      var f = fr.contentWindow && fr.contentWindow.fetch;
      if (typeof f === 'function') {
        _pristineFetch = f.bind(fr.contentWindow);
        return _pristineFetch;
      }
      fr.parentNode.removeChild(fr);
    } catch (e) { /* CSP/realm indisponivel: cai no fetch da pagina */ }
    _pristineFetch = window.fetch.bind(window);
    return _pristineFetch;
  }

  /*
   * Quem descobre que o carrinho mudou embrulhando window.fetch (woolie-gift.js
   * faz isso para rodar a checagem do brinde depois de /cart/add|change|update)
   * nao enxerga o add que passou pelo transporte virgem. Este update VAZIO nao
   * altera nada no carrinho e serve so de aviso para esses ouvintes.
   */
  function notifyCartListeners() {
    try {
      window.fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: {} })
      })['catch'](function () {});
    } catch (e) { /* aviso e best-effort */ }
  }

  /*
   * As sections que o drawer precisa para se redesenhar.
   *
   * O add pede { sections: [...] } e a resposta DEVERIA voltar com elas. Nos
   * produtos que o app de assinaturas gerencia, ela volta so com items: o app
   * embrulha o window.fetch e remove o pedido no caminho. Provado nesta loja, na
   * mesma pagina e com o mesmo corpo: via window.fetch a resposta tem so "items";
   * via XMLHttpRequest e via fetch virgem de iframe tem "items,sections".
   * Correlacao exata com "produto tem plano de assinatura", medida em 4 produtos.
   *
   * Sem as sections o renderContents estoura em "Cannot read properties of
   * undefined (reading 'cart-drawer')" e o add caia no plano B, que e mandar para
   * /cart. Ou seja: em todo produto com assinatura, quem comprava em "Compra
   * unica" perdia o drawer e era jogado numa pagina cheia.
   *
   * POR QUE BUSCAR EM VEZ DE DESVIAR: o caminho obvio seria mandar o add pelo
   * fetch virgem, como o add com plano ja faz. Mas o window.fetch tambem esta
   * embrulhado pelo script de analytics da propria Shopify (visto na pilha de
   * chamadas do console), e desviar dele tira o add da vista de TODO mundo que
   * escuta ali, inclusive o evento de "adicionou ao carrinho". Buscar as sections
   * numa segunda chamada custa uma requisicao, so quando faltou, e nao esconde
   * nada de ninguem. Tambem sobrevive a um app novo fazendo a mesma coisa amanha.
   */
  function garanteSections(parsed, ids) {
    if (!parsed || parsed.sections) return Promise.resolve(parsed);
    if (!ids || !ids.length) return Promise.resolve(parsed);
    return fetch('/?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (mapa) {
        if (mapa && typeof mapa === 'object') parsed.sections = mapa;
        return parsed;
      })
      ['catch'](function (e) {
        // Sem as sections o passo seguinte manda para /cart, que continua sendo um
        // desfecho honesto: o item esta no carrinho e o cliente vai ve-lo.
        console.error('[pp2] nao consegui buscar as sections do drawer', e);
        return parsed;
      });
  }

  function doAddToCart(btn) {
    var lab = btn.querySelector('.p-cta__label');
    var old = lab ? lab.textContent : '';
    var v = variant();
    if (!v.available) return;
    var item = { id: v.id, quantity: state.qty };
    var pl = nativePlan();
    var expectPlan = subAtivo();
    if (expectPlan) item.selling_plan = pl.plan_id;

    /* Pre-venda: o plano do STOQ viaja no MESMO campo selling_plan. Nao coexiste
       com assinatura em nenhum produto de hoje, e o `else` deixa explicito que
       sao exclusivos no add, pra ninguem sobrescrever o plano de assinatura. */
    var preVenda = !expectPlan && preVendaAtiva();
    if (preVenda) {
      item.selling_plan = cfg.pre_venda_plano_id;
      var props = {};
      /* SEM prefixo "_": propriedade que comeca com underscore fica OCULTA na
         vitrine e no pedido pro cliente. Estas duas precisam aparecer: uma e
         registro de consentimento sobre prazo, a outra e o prazo em si, que a
         expedicao le. */
      if (cfg.pre_venda_prop_aceite_ativa && cfg.pre_venda_prop_aceite) {
        props[cfg.pre_venda_prop_aceite] =
          new Date().toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
      }
      if (cfg.pre_venda_prop_envio_ativa && cfg.pre_venda_prop_envio) {
        props['Envio a partir de'] = cfg.pre_venda_prop_envio;
      }
      if (Object.keys(props).length) item.properties = props;
    }

    // So o add COM plano precisa fugir do interceptador. Compra unica e combo
    // seguem no window.fetch para nao furar quem depende dele (brinde e afins).
    // Qualquer add COM selling_plan foge do interceptador do Appstle, que descarta
    // o campo quando o widget dele nao esta no DOM, que e o caso na v3. Vale pra
    // assinatura E pra pre-venda: sem isto o item entra sem o plano de pre-venda.
    var comPlano = expectPlan || preVenda;
    var cartFetch = comPlano ? pristineFetch() : window.fetch.bind(window);

    // Combo "compre junto": cada add-on marcado vira uma LINHA extra no mesmo /cart/add.js
    // (o item principal continua items[0]). O desconto real do combo e o desconto
    // automatico BXGY nativo; aqui so mandamos as linhas juntas.
    // SO NA COMPRA UNICA: a guarda de assinatura desfaz apenas items[0]; se levasse
    // add-ons junto, um add falho de assinatura deixaria as linhas dos add-ons ORFAS
    // no carrinho (o carrinho errado silencioso que a guarda existe pra impedir).
    var comboItems = [];
    // Tambem vale pra pre-venda: se o add com plano falhar, a guarda abaixo desfaz
    // items[0] e as linhas de add-on ficariam orfas no carrinho.
    if (!comPlano) {
      $all('[data-wl-combo-cb]').forEach(function (cb) {
        if (!cb.checked) return;
        if (cb.getAttribute('data-available') === 'false') return;
        var addonId = Number(cb.getAttribute('data-addon-id'));
        if (!addonId || addonId === v.id) return;
        comboItems.push({ id: addonId, quantity: 1 });
      });
    }

    btn.setAttribute('disabled', '');
    btn.setAttribute('data-busy', '1');
    if (lab) lab.textContent = 'Adicionando…';

    var drawer = document.querySelector('cart-drawer');
    var sections = (drawer && typeof drawer.getSectionsToRender === 'function')
      ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];

    cartFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item].concat(comboItems), sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function (parsed) {
        var addedItem = parsed.items && parsed.items[0];
        if (comPlano && addedItem && !addedItem.selling_plan_allocation) {
          return cartFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: addedItem.key, quantity: 0 })
          }).then(function () {
            throw { description: 'Assinatura indisponível no momento' };
          });
        }
        return parsed;
      })
      .then(function (parsed) {
        // DAQUI PARA BAIXO O ITEM JA ESTA NO CARRINHO.
        //
        // Tudo abaixo e interface, e falha de interface NAO pode ser mostrada como
        // "Erro, tente de novo": relatado pelo Mario em 28/jul, a mensagem aparecia
        // e o produto entrava assim mesmo. O cliente le "tente de novo", clica de
        // novo e leva dois. Por isso cada passo daqui tem a propria protecao e
        // nenhum deles pode cair no .catch la embaixo, que e so do add.

        // o add com plano fugiu do window.fetch; avisa quem escuta por la (brinde)
        if (expectPlan) {
          try { notifyCartListeners(); } catch (e) { console.error('[pp2] notifyCartListeners falhou', e); }
        }
        // desmarca ANTES de renderizar o drawer: os add-ons ja estao no carrinho, e
        // deixar os checkboxes marcados faria um novo clique adicionar tudo de novo.
        if (comboItems.length) {
          try {
            $all('[data-wl-combo-cb]').forEach(function (cb) { cb.checked = false; });
          } catch (e) { console.error('[pp2] limpeza dos add-ons falhou', e); }
        }

        return garanteSections(parsed, sections).then(function (comSections) {
          try {
            if (drawer && typeof drawer.renderContents === 'function' && comSections && comSections.sections) {
              drawer.renderContents(comSections);
            } else {
              window.location.href = (window.routes && routes.cart_url) || '/cart';
              return;
            }
          } catch (e) {
            // O carrinho esta certo, so a gaveta nao abriu. Mandar para /cart e o
            // desfecho honesto: o cliente ve o item que acabou de comprar, em vez de
            // um erro que mente sobre o que aconteceu.
            console.error('[pp2] add funcionou, mas o render do drawer falhou', e);
            window.location.href = (window.routes && routes.cart_url) || '/cart';
            return;
          }

          if (lab) lab.textContent = 'Adicionado ✓';
          setTimeout(function () {
            btn.removeAttribute('data-busy');
            if (lab) lab.textContent = old;
            btn.removeAttribute('disabled');
            render();
          }, 1600);
        });
      })
      .catch(function (err) {
        // A mensagem para o cliente continua curta, mas a causa REAL vai para o
        // console. Sem isto o "Erro, tente de novo" apagava a unica pista que
        // existia: o rotulo some em 2,2s e nada fica registrado, entao qualquer
        // relato depois vira adivinhacao. Cobre as tres origens possiveis aqui:
        // erro do /cart/add.js (description da Shopify), a guarda de assinatura,
        // e excecao do render do drawer.
        try {
          console.error('[pp2] falha ao adicionar ao carrinho', {
            erro: err,
            descricao: err && err.description,
            status: err && err.status,
            variante: item && item.id,
            comPlano: !!comPlano,
            preVenda: !!preVenda,
            addons: comboItems.length
          });
        } catch (e) { /* console indisponivel: nao pode derrubar o fluxo */ }

        var msg = (err && err.description) || 'Erro, tente de novo';
        if (lab) lab.textContent = msg;
        setTimeout(function () {
          btn.removeAttribute('data-busy');
          if (lab) lab.textContent = old;
          btn.removeAttribute('disabled');
          render();
        }, msg.length > 30 ? 5000 : 2200);
      });
  }

  /* ---------- barra fixa: select combinado + visibilidade ---------- */
  function bindStickybar() {
    var sel = $('#StkSelect');
    if (sel) {
      cfg.variants.forEach(function (v) {
        sel.appendChild(makeEl('option', { attrs: { value: String(v.id) }, text: v.title }));
      });
      sel.value = String(variant().id);
      sel.addEventListener('change', function () {
        var vid = parseInt(sel.value, 10);
        for (var i = 0; i < cfg.variants.length; i++) {
          if (cfg.variants[i].id === vid) {
            for (var k = 0; k < optionCount; k++) { state.opt[k] = cfg.variants[i]['option' + (k + 1)]; }
            break;
          }
        }
        buildOptionPickers();
        syncVariantImage();
        render();
      });
    }
    var panel = $('.p-panel'), bar = $('#Pp2Sticky');
    if ('IntersectionObserver' in window && panel && bar) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('show', show);
          // Marca no <body> que a barra de compra esta na tela. O banner de
          // cookies tambem e fixed na base com o MESMO z-index (30) e, por vir
          // depois no DOM, pintava por cima do botao "Adicionar ao carrinho".
          // Com esta classe o CSS sobe o banner e os dois convivem.
          document.body.classList.toggle('pp2-sticky-visivel', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 }).observe(panel);
    }
  }

  /* ---------- frete ---------- */
  /* ---------- frete ----------
     A cotacao vive em assets/frete-cotacao.js (window.WoolieFrete), compartilhada
     com a Duna, a LP dos Bites e a LP de Sao Paulo. O miolo do modulo E o codigo
     que estava aqui, movido: adiciona o produto sempre, congela item e quantidade
     no clique, desfaz exatamente o que adicionou achando a linha por identidade
     (a Shopify recalcula a key quando o item funde), trava reentrancia e grava o
     CEP da sessao.

     Uma diferenca proposital em relacao ao que estava aqui: a base da conta passou
     a ser total_price em vez de items_subtotal_price. O gateway do FreteFlow decide
     a gratuidade sobre subtotal MENOS desconto, e a loja distribui dezenas de
     cupons de pedido por link, entao a frase "Faltam R$ X" pedia menos dinheiro do
     que o necessario para quem entrou por um desses links. */
  function bindFrete() {
    if (!window.WoolieFrete) return;
    window.WoolieFrete.ligar(
      {
        input: $('#Pp2Cep'),
        botao: $('#Pp2CepBtn'),
        saida: $('#Pp2FreteOut'),
        meta: { caixa: $('#Pp2FreteMeta'), texto: $('#Pp2FreteMetaTxt'), barra: $('#Pp2FreteBarra') }
      },
      {
        // Os limiares vem dos settings DESTA secao, e nao do #WoolieFreteRegras
        // global. A frase estatica logo acima do calculador ja e renderizada com
        // esses settings: se o modulo lesse outra fonte, mexer no editor de temas
        // mudaria o texto e nao mudaria a conta, e as duas se contradiriam na
        // mesma tela.
        regras: cfg.frete,

        // Congelado pelo modulo no instante do clique. O preco e o EFETIVO: quem
        // esta assinando ve e paga o preco do plano, e cotar pelo preco cheio fazia
        // a barra pedir menos dinheiro do que o necessario, do mesmo jeito que a
        // base pre-cupom fazia. O plano tambem vai junto, para o item cotado ser o
        // mesmo que ele vai comprar.
        itemParaCotar: function () {
          var v = variant(), pl = nativePlan(), assinando = subAtivo();
          return {
            id: v.id,
            quantity: state.qty,
            price: assinando && pl && pl.price ? pl.price : v.price,
            sku: v.sku,
            selling_plan: assinando && pl ? pl.plan_id : null
          };
        }
      }
    );
  }

  /* ---------- card de medidas (modal proprio da secao) ---------- */
  function bindMeasure() {
    var btn = $('#Pp2MeasureBtn'), modal = $('#Pp2MeasureModal');
    if (!btn || !modal) return;
    var close = $('#Pp2MeasureClose');
    function open() {
      modal.hidden = false;
      modal.focus();
      document.documentElement.style.overflow = 'hidden';
    }
    function shut() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      btn.focus();
    }
    btn.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    modal.addEventListener('click', function (e) { if (e.target === modal) shut(); });
    modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  }

  /* ---------- init ---------- */
  // filtra a galeria ja no primeiro paint (a variante inicial pode nao ser a 1a cor)
  applyGalleryFilter();
bindGalleryNav();
  buildGallery();
  buildOptionPickers();
  bindStaticEvents();
  bindStickybar();
  bindFrete();
  bindMeasure();
  bindNotify();
  bindVolume();
  render();

  // Koin carrega assincrono: tenta ligar o sync ate o widget existir (max ~10s).
  (function waitKoin(tries) {
    if (initKoinSync() || tries <= 0) return;
    setTimeout(function () { waitKoin(tries - 1); }, 500);
  })(20);
})();
